import {
    DEV_FIVERR_HOST_PATTERN,
    MIRA_DEV_URL,
    MIRA_ENTRY_PATH,
    MIRA_PROD_URL,
    PROD_FIVERR_HOST_PATTERN,
} from './constants';

interface BuildMiraEntryUrlParams {
    prompt: string;
    source: string;
    variation?: string;
    guest?: boolean;
    hostname?: string;
}

export const isMiraProdHost = (hostname: string): boolean =>
    PROD_FIVERR_HOST_PATTERN.test(hostname) && !DEV_FIVERR_HOST_PATTERN.test(hostname);

/**
 * Builds the Recruiter (MIRA) agentic entry URL — `GET /api/v1/entry/start?prompt=…&source=…`.
 * Host resolves by environment: prod (any *.fiverr.com) → mira.fiverr.com, else
 * recruiter.f-labs.dev. Reusable across any Perseus search/brief entry point that hands
 * off to Mira.
 */
export const buildMiraEntryUrl = ({
    prompt,
    source,
    guest,
    hostname = window.location.hostname,
    variation,
}: BuildMiraEntryUrlParams): string => {
    const miraUrl = new URL(MIRA_ENTRY_PATH, isMiraProdHost(hostname) ? MIRA_PROD_URL : MIRA_DEV_URL);
    miraUrl.searchParams.set('prompt', prompt);
    miraUrl.searchParams.set('source', source);

    if (guest) {
        miraUrl.searchParams.set('guest', '1');
    }

    if (variation) {
        miraUrl.searchParams.set('variation', variation);
    }

    return miraUrl.toString();
};

export const navigateToMiraEntry = (params: BuildMiraEntryUrlParams): void => {
    window.location.assign(buildMiraEntryUrl(params));
};
